import React from "react";
import _ from "lodash";

import IColumn from "models/IColumn";
import { PictureAsPdf } from "components/Icons";
import { downloadDocument } from "helpers/download";
import { markAsRead } from "../app/actions";

export const columns: IColumn[] = [
  {
    key: "checkbox",
    isSortable: false,
    fixedWidth: 52,
    visible: true,
    notRowClick: true
  },
  {
    key: "pdf",
    isSortable: false,
    render: rowData => (
      <PictureAsPdf
        id={`download-account-statements-${rowData.DocumentId}.pdf`}
        onClick={e => {
          e.stopPropagation();
          downloadDocument(
            rowData,
            () =>
              !_.get(rowData, "Read", true) &&
              markAsRead([rowData.Id], "RekeningOverzicht")
          );
        }}
      />
    ),
    fixedWidth: 52,
    visible: true,
    notRowClick: true
  },
  {
    title: "PAYMENT_DATE",
    key: "PaymentDate",
    fixedWidth: 196,
    type: "date",
    visible: true
  },
  {
    title: "SERIAL_NR",
    key: "Version",
    visible: true
  },
  {
    title: "ACCOUNT_STATEMENTS_DATE",
    key: "DocumentDate",
    type: "date",
    visible: true
  },
  {
    title: "BALANCE",
    key: "PreviousBalance",
    type: "currency",
    visible: true
  },
  {
    title: "CLOSING_BALANCE",
    key: "EndSaldo",
    type: "currency",
    visible: true
  },
  {
    title: "ACCOUNT_STATEMENTS_NR",
    key: "Number",
    visible: false
  }
];
